import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'uniqueMapValues',
  pure: false
})
export class UniquePipe implements PipeTransform {
  transform(array: any, key: string): any[] {
    if(!array){
      return [];
    }
    if (key == null) {
      // Return input unchanged if key is null or undefined
      return array;
    }
    const arrayUniqueByKey = array.map(item => {
      return {
        key: item.key,
        value: [...new Map(item.value.map(item => [item[key], item])).values()],
      }
    })
    return arrayUniqueByKey;
  }
}
